import {
  useState,
  useEffect
} from 'react';

import {
  isMobileView
} from 'src/Utility/utility';

export const useDeviceType = () => {
  const [ isMobile, setIsMobile ] = useState(isMobileView());

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(isMobileView());
    };

    window.addEventListener('resize', handleResize);
    handleResize();

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return isMobile;
};